export default {"src":"/_next/static/media/plus-icon.0d084953.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};